import { Injectable } from '@angular/core';
import {BettingGamesHttpService} from "@api/http/betting-games/betting-games-http.service";
import {IBettingGame} from "@api/models/betting-game/betting-game";
import {MatchService} from "@lib-modules/match/services/match/match.service";

@Injectable({
  providedIn: 'root'
})
export class MatchBannerService {

  public loading = true;
  public activeBetting: IBettingGame;

  constructor( private bettingGamesHttpService: BettingGamesHttpService,
               private matchService: MatchService) { }

  public async init(): Promise<void> {
    try {
      this.loading = true;
      const response = await this.bettingGamesHttpService.getActive();
      for (const active of response.data) {
        const response = await this.bettingGamesHttpService.getBetting(active._id);
        const betting = response.data;
        if (betting.leagueid === this.matchService.league._id) {
          this.activeBetting = betting;
          break;
        }
      }
      this.loading = false;
    } catch (e) {
      this.loading = false;
      throw e;
    }
  }

  public get webUrl(): string | undefined {
    return this.activeBetting?.description?.web_url;
  }

  public get bannerImgUrl(): string | undefined {
    return this.activeBetting?.description?.cta_banner;
  }
}
